var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0003 15.6531L16.1325 16.8138L13.8912 12.171H9.40841M9.40841 12.171H8.66124L7.16699 5.98047H8.66124L8.86874 7.69964M9.40841 12.171L8.86874 7.69964M8.86874 7.69964H12.167",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9047 15.7859C13.5054 15.3866 12.8107 15.5386 12.4633 15.9837C11.7508 16.8965 10.6403 17.4834 9.39267 17.4834C7.24262 17.4834 5.49967 15.7405 5.49967 13.5905C5.49967 12.5812 5.88375 11.6616 6.51371 10.97C6.75587 10.704 6.87832 10.3374 6.77497 9.99287C6.60679 9.43229 5.94717 9.18804 5.52658 9.59504C4.48224 10.6058 3.83301 12.0223 3.83301 13.5905C3.83301 16.661 6.32214 19.15 9.39267 19.15C11.32 19.15 13.0183 18.1694 14.0157 16.6797C14.2045 16.3977 14.1447 16.0259 13.9047 15.7859Z",
    fill: "#262626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04134 2.69987C9.04134 3.27516 8.57497 3.74154 7.99967 3.74154C7.42437 3.74154 6.95801 3.27516 6.95801 2.69987C6.95801 2.12457 7.42437 1.6582 7.99967 1.6582C8.57497 1.6582 9.04134 2.12457 9.04134 2.69987Z",
    fill: "#262626",
    stroke: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledSeat);
export default __webpack_public_path__ + "static/media/disabledSeat.3e79e5e5eb33152f73a251d6606162bb.svg";
export { ForwardRef as ReactComponent };